import { accountQueryKeys } from 'queries/account-query-keys';
import { FilterParams } from 'types/params';

export const widgetQueryKeys = {
    widgets: (accountId: number) => [...accountQueryKeys.current(accountId), 'widgets'],
    widgetsWithFilters: (accountId: number, filters: FilterParams = {}) => [
        ...widgetQueryKeys.widgets(accountId),
        filters,
    ],
    widgetsByCampaignId: (accountId: number, campaignId: number) => [
        ...widgetQueryKeys.widgets(accountId),
        'campaign',
        campaignId,
    ],
    sdk: (accountId: number) => [...accountQueryKeys.current(accountId), 'widgets-sdk'],
    widget: (accountId: number, widgetId: number) => [
        ...widgetQueryKeys.widgets(accountId),
        widgetId,
    ],
    libraryStatus: (accountId: number) => [accountId, 'widgets-library-status'],
};
